import { Edit, SimpleForm, TextInput, NumberInput } from "react-admin";

const PaymentMethodEdit = (props) => {
  return (
    <Edit {...props}>
      <SimpleForm>
        <TextInput source="locale" defaultValue="th-TH" disabled />
        <TextInput source="status" defaultValue="Active" disabled />
        <TextInput source="name" />
        <TextInput source="desc" />
        <NumberInput source="__v" />
      </SimpleForm>
    </Edit>
  );
};

export default PaymentMethodEdit;
